import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
window.addEventListener('load', function() {
    var /* BOTTOM
	-------------------------------------------------- */ _document_querySelectorAll, /* PARALLAX
	-------------------------------------------------- */ _document_querySelectorAll1, /* SCALE
	-------------------------------------------------- */ _document_querySelectorAll2, /* ROW
	-------------------------------------------------- */ _document_querySelectorAll3, /* REVEAL
	-------------------------------------------------- */ _document_querySelectorAll4, /* CHECK VIEWPORT
	-------------------------------------------------- */ _document_querySelectorAll5, _document_querySelectorAll6;
    (_document_querySelectorAll = document.querySelectorAll('[data-animation-bottom]')) === null || _document_querySelectorAll === void 0 ? void 0 : _document_querySelectorAll.forEach(function($item) {
        gsap.fromTo($item, {
            y: '0'
        }, {
            y: '20%',
            ease: 'linear',
            scrollTrigger: {
                trigger: $item,
                start: 'bottom+=15% bottom',
                end: 'bottom top',
                scrub: true,
                invalidateOnRefresh: true
            }
        });
    });
    (_document_querySelectorAll1 = document.querySelectorAll('[data-animation-parallax]')) === null || _document_querySelectorAll1 === void 0 ? void 0 : _document_querySelectorAll1.forEach(function($item) {
        gsap.fromTo($item, {
            y: '-16%'
        }, {
            y: '16%',
            ease: 'linear',
            scrollTrigger: {
                trigger: $item,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true,
                invalidateOnRefresh: true
            }
        });
    });
    (_document_querySelectorAll2 = document.querySelectorAll('[data-animation-scale]')) === null || _document_querySelectorAll2 === void 0 ? void 0 : _document_querySelectorAll2.forEach(function($item) {
        gsap.fromTo($item, {
            scale: '1.2'
        }, {
            scale: '1',
            ease: 'linear',
            scrollTrigger: {
                trigger: $item,
                start: 'top center',
                invalidateOnRefresh: true,
                toggleActions: 'restart none none reverse'
            }
        });
    });
    (_document_querySelectorAll3 = document.querySelectorAll('[data-animation-row]')) === null || _document_querySelectorAll3 === void 0 ? void 0 : _document_querySelectorAll3.forEach(function($item) {
        var direction = $item.dataset.animationRow;
        gsap.fromTo($item, {
            x: '0'
        }, {
            x: function() {
                var way = $item.clientWidth - $item.parentElement.clientWidth;
                if (direction === 'right') way = way * -1;
                if (window.innerWidth <= 900) way = 0;
                return "".concat(way / 10, "rem");
            },
            ease: 'linear',
            scrollTrigger: {
                trigger: $item,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true,
                invalidateOnRefresh: true
            }
        });
    });
    (_document_querySelectorAll4 = document.querySelectorAll('[data-animation-reveal]')) === null || _document_querySelectorAll4 === void 0 ? void 0 : _document_querySelectorAll4.forEach(function($item) {
        ScrollTrigger.batch($item, {
            start: 'top bottom-=10%',
            onEnter: function(batch) {
                batch.forEach(function(el) {
                    return el.classList.add('-is-visible');
                });
                gsap.to(batch, {
                    y: 0,
                    opacity: 1,
                    duration: 1,
                    stagger: {
                        each: 0.15,
                        overwrite: true
                    }
                });
            }
        });
    });
    (_document_querySelectorAll5 = document.querySelectorAll('[data-check-viewport]')) === null || _document_querySelectorAll5 === void 0 ? void 0 : _document_querySelectorAll5.forEach(function($item) {
        ScrollTrigger.batch($item, {
            start: 'top bottom-=20%',
            onEnter: function() {
                $item.classList.add('-animation-start');
            }
        });
    });
    /* ANIMATION NUMBER
	-------------------------------------------------- */ var numberFormat = function(number, afterPoint) {
        return parseFloat(number).toFixed(afterPoint).replace('.', ',');
    };
    (_document_querySelectorAll6 = document.querySelectorAll('[data-number-animation]')) === null || _document_querySelectorAll6 === void 0 ? void 0 : _document_querySelectorAll6.forEach(function($number) {
        var unit = $number.dataset.numberUnit;
        var numberData = $number.dataset.numberAnimation;
        var afterPoint = numberData.includes(',') ? numberData.split(',').pop().length : 0;
        var numberNumber = parseFloat(numberData.replace(',', '.'));
        var step = afterPoint > 0 ? 1 / Math.pow(10, afterPoint) : 1;
        var numbers = [
            numberData,
            afterPoint
        ];
        if (isNaN(numberNumber)) {
            numbers = [
                '',
                '',
                numberData
            ];
        } else {
            var numberFull = numberNumber.toFixed(afterPoint);
            numbers = [
                numberFormat(numberFull - (step + step), afterPoint),
                numberFormat(numberFull - step, afterPoint),
                numberFormat(numberFull, afterPoint)
            ];
        }
        var numberIndex = 0;
        $number.innerHTML = "\n			".concat(numbers[2].split('').map(function(item, index) {
            numberIndex = index;
            return '\n						<div style="--char-index: '.concat(numberIndex, ';">\n							<span>').concat(numbers[0][index] || '&nbsp;', "</span>\n							<span>").concat(numbers[1][index] || '&nbsp;', "</span>\n							<span>").concat(item, "</span>\n						</div>\n					");
        }).join(''), "\n			").concat(unit ? unit.split('').map(function(item) {
            numberIndex += 1;
            return '\n									<div class="number__measure" style="--char-index: '.concat(numberIndex, ';">\n										<span>&nbsp;</span>\n										<span>&nbsp;</span>\n										<span>').concat(item, "</span>\n									</div>\n								");
        }).join('') : '', "\n		");
    });
    /* HOME
	-------------------------------------------------- */ var $homeHolder = document.querySelector('[data-home-holder]');
    var $homeHolderContent = document.querySelector('[data-home-holder-content]');
    var $honeItem = document.querySelectorAll('[data-home-item]');
    if ($honeItem.length) {
        $honeItem.forEach(function($item) {
            gsap.fromTo($item, {
                y: function() {
                    var y = '20%';
                    if (window.innerWidth <= 900) y = '0%';
                    return y;
                }
            }, {
                y: '0%',
                ease: 'linear',
                scrollTrigger: {
                    trigger: $homeHolder,
                    start: 'top top+=25%',
                    end: 'bottom bottom',
                    scrub: true,
                    invalidateOnRefresh: true
                }
            });
        });
        gsap.fromTo($homeHolderContent, {
            y: '0%'
        }, {
            y: function() {
                var previewHeight = $homeHolder.clientHeight;
                var listHeight = $homeHolderContent.clientHeight;
                return "".concat((previewHeight - listHeight) / listHeight * 100, "%");
            },
            ease: 'linear',
            scrollTrigger: {
                trigger: $homeHolder,
                start: 'top top+=25%',
                end: 'bottom bottom',
                scrub: true,
                invalidateOnRefresh: true
            }
        });
    }
});
